import React, { useState, useCallback } from 'react'

import ActionSelect from './ActionSelect'

const allowedActions = ['goToStep']

const Step = ({ action, onChange }) => {
  const [prechatAction, setPrechatAction] = useState(action?.action || {})

  const onSetAction = useCallback(
    (act) => {
      setPrechatAction({ ...act })
      onChange({
        action: act
      })
    },
    [onChange]
  )

  return (
    <div className='select-action'>
      <div className='label'>What happens after submitting the form?</div>
      <ActionSelect action={prechatAction} setAction={onSetAction} allowedActions={allowedActions} />
    </div>
  )
}

export default Step
